<template lang="pug">
  div(v-if="clubOne")
    portal(to="pageTitle")
      span Редактировать клуб

    v-container
      Settings(
        :languages="languages"
        :locale="locale"

        @languageChanged="onLanguageChanged"
      )

      .mt-10

      Content(
        :sort="sort"
        :name="name"
        :description="description"
        :image="image"
        @sortChanged="onSortChanged"
        @nameChanged="onNameChanged"
        @descriptionChanged="onDescriptionChanged"
        @imageChanged="onImageChanged"
      )

      .mt-10

      Controls(
        hasDelete
        @save="onSave"
        @delete="onDelete"
      )

</template>

<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import GetGQL from '../../graphql/private/Club/Get.gql'
import UpdateGQL from '../../graphql/private/Club/Update.gql'
import RemoveGQL from '../../graphql/private/Club/Remove.gql'

export default {
  name: 'clubs__id',
  components: {
    Settings,
    Content,
    Controls,
  },
  mixins: [Mixin, notify],
  data() {
    return {
      routeId: this.$route.params.id,
    }
  },

  apollo: {
    clubOne: {
      query: GetGQL,
      variables() {
        return {
          filter: {
            id: this.routeId,
            locale: this.locale,
          },
        }
      },
    },
  },
  methods: {
    async onSave() {
      try {
        await this.$apollo.mutate({
          mutation: UpdateGQL,
          variables: {
            club: {
              id: this.routeId,
              active: true,
              image: this.imageFile,
              locale: this.locale,
              sort: this.sort,
              name: this.name,
              description: this.description,
            },
          },
        })

        await this.$apollo.queries.clubOne.refetch()
        this.imageFile = null

        this.notify({
          text: 'Достижение обновлено!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },

    async onDelete() {
      try {
        await this.$apollo.mutate({
          mutation: RemoveGQL,
          variables: {
            id: this.routeId,
          },
        })

        this.notify({
          text: 'Достижение удалено!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
      await this.$router.push({
        name: 'clubs__list',
      })
    },
  },

  watch: {
    clubOne(club) {
      if (!club) {
        this.$router.push({
          name: 'clubs__list',
        })
      }
      const pst = {
        ...club,
      }
      for (const field in pst) {
        this[field] = pst[field]
      }
      this.files = this.attachments
    },
  },
}
</script>
